module.exports = "/assets/img/restaurant/ccf6136f3c2849db90c80cd97c2cb250.png";